import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
import httpClient from "@/common/service/HttpClient";
import { defaultAPICloudSetting } from "@/constants/apiSetting";
const SysMsgService = {
  async setupSysMsg({ dispatch }, langCode) {
    const lang = store.getters[StoreGetter.lang];
    dispatch({
      type: `SysMsgStore/refreshStore`,
      payload: { lang: lang }
    });
  },
  async getMsg(lang) {
    const reqObj = {
      languageCode: lang
    };
    return httpClient.post(
      `localization/${lang}/messages`,
      reqObj,
      defaultAPICloudSetting
    );
  },
  t(key) {
    const sysMsg = store.getters[StoreGetter.sysMsg];
    const value = sysMsg[key] ? sysMsg[key] : key;
    return value;
  }
};

export default SysMsgService;

export const setupSysMsg = async store => {
  const lang = store.getters[StoreGetter.lang];
  const res = await SysMsgService.getMsg(lang);
  if (res.data.IsSuccess) {
    store.dispatch({
      type: `SysMsgStore/refreshStore`,
      payload: res.data.Data
    });
  }
};



// WEBPACK FOOTER //
// ./src/service/SysMsgService.js